import { useEffect, useState } from "react";
import { bool, func, number, string } from "prop-types";
import { Dialog, TextField, Button } from "@components";
import { CircularProgress } from "@material-ui/core";

export const NameEditorModal = ({
  open,
  onClose,
  confirmButtonTitle,
  title,
  defaultName,
  useBackdropClick,
  width=320,
}) => {

  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState(defaultName || "");

  useEffect(() => {
    setName(defaultName || "");
  }, [open]);

  const handleClick = async () => {
    setLoading(true);
    await onClose(name.trim());
    setLoading(false);
  };

  const handleChange = (e) => {
    setName(e.target.value.replace(/[$\\+[\]^{}`]/g, "").slice(0, 30));
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      width={width}
      useBackdropClick={useBackdropClick}
      containerClass="py-3"
      actions={
        <Button
          disabled={!name || defaultName === name}
          variant="contained"
          onClick={handleClick}
          className="w-max"
        >
          {
            isLoading
              ? <CircularProgress size={16} className="text-alt" />
              : confirmButtonTitle
          }
        </Button>
      }
    >
      <TextField
        value={name}
        label={title}
        onChange={handleChange}
        className="my-4"
      />
    </Dialog>
  );
};

NameEditorModal.propTypes = {
  title: string,
  confirmButtonTitle: string,
  open: bool.isRequired,
  onClose: func.isRequired,
  defaultName: string,
  useBackdropClick: bool,
  width: number,
};
